import React, { useEffect } from 'react';
import { SelectPicker } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAll as getLocationOptions,
  getFetched
} from '../../redux/Guest/selectors/user-location-options';
import { fetchUserLocationOptions } from '../../redux/Guest/sagas/routines';

export default function LocationSelectPicker(props) {
  const dispatch = useDispatch();
  const locationOptions = useSelector(getLocationOptions);
  const isFetched = useSelector(getFetched);
  useEffect(
    () => {
      if (!isFetched) dispatch(fetchUserLocationOptions());
    },
    [isFetched]
  );

  return <SelectPicker {...props} data={locationOptions} />;
}
